import Form from "../helpers/Form";
import Popup from "../helpers/Popup";

$(document).ready(function () {
    $('input.number').number(true, 0, ',', ' ');

    $(document).on('submit', '[data-form]', function (e) {
        e.preventDefault();

        const form = $(this),
            formObj = new Form(form),
            formData = form.serialize(),
            submit = form.find('button, [type=submit]');

        if (!formObj.isValid()) {
            for (let name in formObj.errors) {
                formObj.showError(name, formObj.errors[name]);
            }
            return;
        }

        submit.prop('disabled', true);
        form.find('input').val('');

        $.ajax({
            type: 'JSON',
            url: '/ajax/form/send/',
            method: 'POST',
            data: formData,
            beforeSend: () => {
                submit.attr('disabled', 'disabled').prop('disabled', true);
                form.parent().find('.popup__close').click();
                Popup.get('#popup').close();
                Popup.message(false, 'success');
            },
            success: () => {
                form.find('input').each(function () {
                    if ($(this).attr('type') === 'hidden')
                        return;
                    $(this).val('');
                    dataLayer.push({'event': 'formsend'});
                });
            },
            error: () => {
                Popup.message(false, 'error');
            },
            complete: () => {
                (dataLayer = window.dataLayer || []).push({
                    'event': 'UAEvent',
                    'ga_eventname': 'form-send-callback',
                    'eCategory': 'form',
                    'eAction': 'send',
                    'eLabel': 'callback',
                    'eNi': '0'});

                submit.attr('disabled', '').prop('disabled', false);
            },
        });

    });
});